// Shared input transform registry used by frontend validated inputs.
export const inputTransforms = {
    lowercase: (value) => value.toLowerCase(),
    capitalizeFirst: (value) => value.replace(/^./, (character) => character.toUpperCase()),
    titleCaseWords: (value) => value
        .split(' ')
        .map((word) => word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : word)
        .join(' '),
    uppercase: (value) => value.toUpperCase(),
    collapseWhitespace: (value) => value.replace(/\s+/g, ' '),
    stripOuterWhitespace: (value) => value.trim(),
};
export function applyInputTransform(transformName, value) {
    const [name, params] = transformName.split(':');
    const transform = inputTransforms[name];
    if (!transform) {
        console.warn(`Unknown input transform: ${name}`);
        return value;
    }
    return transform(value, params);
}
export function applyInputTransforms(transformNames, value) {
    return transformNames.reduce((currentValue, transformName) => applyInputTransform(transformName, currentValue), value);
}
//# sourceMappingURL=inputTransforms.js.map